<div id="merchant-form-wrapper">
  <form [formGroup]="merchantForm" id="merchant-form" data-cy="merchant-form">
    <div class="full-width merchant-form-section">
      <ep-email-control class="full-height-width" formControlName="Email" data-cy="merchant-email"></ep-email-control>
      <div class="serial-number-control-wrapper">
        <label for="merchant-serial-number" class="serial-number-label">TPN (Optional)</label>
        <input
          id="merchant-serial-number"
          pInputText
          type="text"
          class="full-height-width"
          formControlName="SerialNumber"
          maxlength="255"
          data-cy="merchant-serial-number"
        />
      </div>
      <!-- <app-merchant-payment-type-control
        class="full-height-width"
        formControlName="PaymentType"
        data-cy="merchant-payment-type"
      ></app-merchant-payment-type-control> -->
    </div>
    <div class="full-width merchant-form-section">
      <ep-price-control
        class="full-height-width"
        formControlName="BasePrice"
        label="Base Monthly Price"
        data-cy="merchant-base-price"
      ></ep-price-control>
      <app-merchant-sms-price-control
        class="full-height-width"
        formControlName="PricePerSms"
        label="Price Per Sms"
        data-cy="merchant-sms-price"
      ></app-merchant-sms-price-control>
    </div>
  </form>
</div>
